import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import { useForm } from "react-hook-form";
import { FormContainer } from "../../Form/FormContainer/FormContainer"
import UserIcon from "../../../public/images/icons/user.svg";
import SaveIcon from "../../../public/images/icons/save.svg";
import { FormControl } from "../../Form/FormControl/FormControl";
import { Input } from "../../Form/Inputs/Input";
import { TextArea } from "../../Form/Inputs/TextArea";
import { VerificationRequiredNotification } from "../../Create/Paid/VerificationRequiredNotification";
import { SubmitButton } from "../../Form/SubmitButton/SubmitButton";
import { useCallback, useEffect } from "react";
import { AvatarChooser } from "./AvatarChooser";
import { setProfile } from "@jconradi/tutu-porn-api-client/src/me";
import { useMe } from "../../../hooks/useMe";
import { Spinner } from "../../Spinner/Spinner";
import useTranslation from "next-translate/useTranslation";

type EditProfileFormData = {
    name: string;
    description: string;
    site: string;
};
const urlRegex = '^(https?:\\/\\/)?'+ // validate protocol
'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
'((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
'(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
'(\\#[-a-z\\d_]*)?$';
const EditProfileFormSchema = Joi.object({
    name: Joi.string().allow('').max(50),
    description: Joi.string().allow('').max(500),
    site: Joi.string().allow('').max(256).regex(new RegExp(urlRegex)).message('Invalid URL')
});
export const EditProfile = () => {
    const me = useMe();
    const { t } = useTranslation('settings');

    const form = useForm<EditProfileFormData>({
        resolver: joiResolver(EditProfileFormSchema)
    });
    const {
        register,
        handleSubmit,
        setError,
        reset,
        formState: { errors, isSubmitting },
    } = form;

    const onSubmit = async (data: EditProfileFormData) => {
        try {
            await setProfile(data);
        }
        catch (err) {
            console.error(err);
            setError('site', {
                message: 'Invalid URL'
            })
        }
    };

    useEffect(() => {
        const data = me.data?.data;
        reset({
            name: data?.name,
            description: data?.description,
            site: data?.site
        });
    }, [me.data?.data])

    if (me.isLoading) {
        return <Spinner className="mx-auto" />
    }

    return (
        <div className="rounded-2xl bg-base-300 sm:ml-4 py-8 flex-1 px-4 sm:px-8 w-full">
            <div className="flex flex-row">
                <UserIcon className="h-8 w-8 mr-2 text-primary stroke-[3px]" />
                <h3 className="text-2xl font-bold">{t('editProfile.title')}</h3>
            </div>
            <AvatarChooser avatar={me.data?.data.avatar} />

            <FormContainer formContentClassName="" form={form} onSubmit={handleSubmit(onSubmit)} className="w-full sm:mx-auto">
                <FormControl>
                    <Input name="name" label={t('editProfile.name.title')} placeholder={t('editProfile.name.title')} type="text" autoComplete="off" autoCorrect="off" autoCapitalize="none" />
                </FormControl>

                <FormControl>
                    <TextArea name="description" label={t('editProfile.description.title')} placeholder={t('editProfile.description.placeholder')} rows="4" autoComplete="off" autoCorrect="off" autoCapitalize="none" />
                </FormControl>

                <FormControl>
                    <Input name="site" label={t('editProfile.website.title')} placeholder={t('editProfile.website.title')} type="text" autoComplete="off" autoCorrect="off" autoCapitalize="none" />
                    <p className="text-sm font-normal">{t('editProfile.website.tooltip')}</p>
                </FormControl>

                <VerificationRequiredNotification />

                <SubmitButton icon={<SaveIcon className="w-8 h-8" />} label={t('editProfile.button')} />

            </FormContainer>


        </div>
    )
}